import { Info } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function FieldWorkerGuideFab() {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate('/field-worker/guides')}
      className="fixed z-40 right-4 bottom-4 w-14 h-14 rounded-full bg-blue-600 text-white shadow-xl hover:bg-blue-700 active:scale-95 transition-all border-2 border-white flex items-center justify-center"
      style={{ bottom: 'max(1rem, calc(env(safe-area-inset-bottom) + 0.75rem))' }}
      aria-label="פתח מדריכים"
      title="מדריכים"
    >
      <Info size={26} />
    </button>
  );
}
